import { navigate } from 'gatsby';
import * as React from 'react';

import { ILinkProps, Link as UnifiLink } from '@nelnet/unifi-components-react';

const Link: React.FunctionComponent<ILinkProps> = ({ children, href = '', ...other }) => {
  const url = href;

  // This assumes that any internal link (intended for Gatsby)
  // will start with exactly one slash, and that anything else is external.
  let internal = /^\/(?!\/)/.test(url);
  const anchor = /^#(?!\/)/.test(url);

  if (url.includes('unifi.nelnet')) {
    internal = true;
  }

  // Use Gatsby navigate for internal links
  if (!url.includes('.pdf') && internal) {
    return (
      <UnifiLink
        href={url}
        onClick={(event: React.MouseEvent) => {
          event.preventDefault();
          navigate(url);
        }}
        {...other}
      >
        {children}
      </UnifiLink>
    );
  }

  if (anchor) {
    return (
      <UnifiLink href={url} {...other}>
        {children}
      </UnifiLink>
    );
  }

  return (
    <UnifiLink href={url} target="_blank" {...other}>
      {children}
    </UnifiLink>
  );
};

export default Link;
